module.exports = __webpack_public_path__ + "media/images/common/card-arrow-735e04e6e6e9e4311260c619b3769707.svg";